import axios from "axios";
import ProductItem from "./ProductItem";
import { useEffect, useState } from "react";
import Category from "../Category/Category";
import { useSelector } from "react-redux";
import { categoryActions } from "../../../store/category-slice";
import { useDispatch } from "react-redux";
import { baseURL, basics } from "../../../basics";
import ProductItemInMobile from "./ProductItemInMobile";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "../../Ui/Loading";
import {
  fetchShowAllProductsHandler,
  fetchShowProductsHandler,
  fetchShowSpecialsHandler,
} from "../../../store/category-actions";
// import { Link, Route, Switch, useParams } from "react-router-dom";
// import { categoryActions } from "../../../store/category-actions";
const ListOfProducts = () => {
  const dispatch = useDispatch();
  const [listOfProductsCanRenderNow, setListOfProductsCanRenderNow] =
    useState(false);

  const [response, setResponse] = useState<any>(false);
  const loading = useSelector((state: any) => state.category.loading);
  const categoryId = useSelector((state: any) => state.category.categoryId);
  const typeOfProductsCategories = useSelector(
    (state: any) => state.category.typeOfProductsCategories
  );
  const hasMore = useSelector((state: any) => state.category.hasMore);
  // const hasMore = true;
  // const [productsLength, setProductsLength] = useState();
  const productsLength = useSelector(
    (state: any) => state.category.productsLength
  );
  const categoryIdHandler = useSelector(
    (state: any) => state.category.categoryId
  );
  const itemsPerPage = useSelector((state: any) => state.category.itemsPerPage);
  const currentPage = useSelector((state: any) => state.category.page);
  // const [dataProduct, setDataProduct] = useState([""]);
  const dataProduct: any = useSelector(
    (state: any) => state.category.dataOfProducts
  );

  const nextProductsList = () => {
    dispatch(categoryActions.nextPage());
    // console.log("asdasdasdasdasdasdasdasdasd", currentPage, itemsPerPage);
  };
  // console.log("currentPage", currentPage);
  if (dataProduct.length < productsLength) {
    dispatch(categoryActions.setHasMore(true));
    // console.log('setHasMore(true');
  }
  // useEffect(()=>{
  //   dispatch(categoryActions.setHasMore(true))
  // },[dispatch])
  useEffect(() => {
    dispatch(categoryActions.newCategoryIsSelected());
    setListOfProductsCanRenderNow(true);
    // console.log("hasMore", hasMore);
  }, [dispatch]);
  // useEffect(() => {
  //   setWeHaveMore(hasMore)
  // }, [hasMore]);
  useEffect(() => {
    // console.log("1", "haseMore:", hasMore);
    setResponse(false);
    if (typeOfProductsCategories === "special") {
      // console.log("2", "haseMore:", hasMore);
      dispatch(fetchShowSpecialsHandler(currentPage, itemsPerPage));
      setResponse(true);
    } else if (typeOfProductsCategories === "allProducts") {
      // console.log("3", "haseMore:", hasMore);
      dispatch(fetchShowAllProductsHandler(currentPage, itemsPerPage));
      setResponse(true);
    } else {
      // console.log("4", "haseMore:", hasMore);
      dispatch(fetchShowProductsHandler(currentPage, itemsPerPage, categoryId));
      setResponse(true);
      // axios({
      //   method: "get",
      //   url: `${baseURL}api/Product/GetByCategory?CategoryId=${categoryIdHandler}`,
      //   responseType: "stream",
      // })
      //   .then(function (response: any) {
      //     const data: any = response.data.totalItems;
      //     dispatch(categoryActions.totalItemsOfCategory(data));
      //     setResponse(true);
      //   })
      //   .catch(function (error: any) {
      //     // console.log("error", error);
      //     setResponse(false);
      //   });
    }
  }, [
    categoryId,
    categoryIdHandler,
    currentPage,
    dispatch,
    itemsPerPage,
    typeOfProductsCategories,
  ]);

  // console.log(
  //   "dataProduct.length:",
  //   dataProduct.length,
  //   "haseMore:",
  //   hasMore,
  //   "tate.category.productsLength:",
  //   productsLength
  // );
  // if (!response) {
  //   return (
  //     <div className="my-24 mx-auto">
  //       <Loading />
  //     </div>
  //   );
  // }
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Define your breakpoint here

  useEffect(() => {
    // Function to handle window resize and update isMobile state
    function handleResize() {
      setIsMobile(window.innerWidth <= 640); // Update the breakpoint as needed
    }

    // Attach the event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // console.log("isMobile", isMobile);
  return (
    <div className="mt-[104px] sm:mt-24 mb-24 max-w-[1400px] mx-auto">
      <div className="flex justify-center fixed top-12 sm:top-0 left-0 right-0 z-10 bg-white/95 backdrop-blur sm:relative text-xl font-bold border-b border-slate-100 sm:border-0">
        <div className="my-3">{basics.products}</div>
      </div>
      {/* <h2 className="flex justify-start text-xl font-extrabold text-gray-900 mx-2">
        {basics.Categories}
      </h2> */}
      <Category />
      <div className="max-w-[1400px] mx-auto px-2 sm:px-4">
        <div className="mx-auto py-4 sm:py-8">
          {!response && !listOfProductsCanRenderNow ? (
            <div className="my-24 mx-auto">
              <Loading />
            </div>
          ) : (
            <InfiniteScroll
              dataLength={dataProduct.length}
              next={nextProductsList}
              hasMore={hasMore} // Replace with a condition based on your data source
              loader={
                <div className="my-24">
                  <Loading />
                </div>
              }
              endMessage={""}
            >
              <ul className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 sm:gap-4 justify-items-center">
                {dataProduct &&
                  dataProduct.map((product: any) =>
                    isMobile ? (
                      <div className="flex flex-col" key={product.id}>
                        <ProductItemInMobile key={product.id} items={product} />
                      </div>
                    ) : (
                      <div className="" key={product.id}>
                        <ProductItem key={product.id} items={product} />
                      </div>
                    )
                  )}
              </ul>
              <ul className="sm:hidden flex flex-col ">
                {/* TODO create one component  instead of ProductItem and ProductItemInMobile*/}
              </ul>
            </InfiniteScroll>
          )}
        </div>
      </div>
    </div>
  );
};
export default ListOfProducts;
